import { render, staticRenderFns } from "./FullPageLoading.vue?vue&type=template&id=2115a5ab&scoped=true&"
import script from "./FullPageLoading.vue?vue&type=script&lang=js&"
export * from "./FullPageLoading.vue?vue&type=script&lang=js&"
import style0 from "./FullPageLoading.vue?vue&type=style&index=0&id=2115a5ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2115a5ab",
  null
  
)

export default component.exports